<template>
  <v-card class="mt-5">
    <v-card-title>My Testing Statistics</v-card-title>
    <v-card-text>
      <v-simple-table>
        <tbody>
          <tr>
            <th>Samples Pending</th>
            <td v-if="isLoading">
              <v-progress-linear indeterminate />
            </td>
            <td v-else>
              <router-link to="/samples/browse?is_pending=true">{{
                stats.pending
              }}</router-link>
            </td>
          </tr>
          <!-- <tr>
            <th>Samples in Transit</th>
            <td v-if="isLoading">
              <v-progress-linear indeterminate />
            </td>
            <td v-else>
              <router-link to="/shipments/browse?in_transit=true">{{
                stats.in_transit
              }}</router-link>
            </td>
          </tr> -->
          <tr>
            <th>Reported Today</th>
            <td v-if="isLoading">
              <v-progress-linear indeterminate />
            </td>
            <td v-else>
              <router-link to="/samples/browse?created_today=true">{{
                stats.reported_today
              }}</router-link>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "TestingStatistics",
  data: () => ({
    isLoading: true,
    selectedClientId: null
  }),
  computed: {
    ...mapState("samples", ["stats"]),
    ...mapGetters("clients", ["selectedClient"]),
    average_transit_days() {
      return !this.stats || this.stats.average_transit_days === null
        ? "NA"
        : this.stats.average_transit_days +
            " day" +
            (this.stats.average_transit_days === 1 ? "" : "s");
    },
    average_nir_return_days() {
      return !this.stats || this.stats.average_nir_return_days === null
        ? "NA"
        : this.stats.average_nir_return_days +
            " day" +
            (this.stats.average_nir_return_days === 1 ? "" : "s");
    }
  },
  methods: {
    ...mapActions("samples", ["getStats"])
  },
  async mounted() {
    this.isLoading = true;
    this.selectedClientId = this.selectedClient.id;
    await this.getStats(this.selectedClientId);
    this.isLoading = false;
    this.options.params.client_id = this.selectedClient.id;
  },
  watch: {
    selectedClient(newVal) {
      this.selectedClientId = newVal ? newVal.id : null;
      this.getStats(this.selectedClientId);
    }
  }
};
</script>

<style scoped></style>
